var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"resource__head"},[_c('h1',{staticClass:"h2 resource__title",domProps:{"innerHTML":_vm._s(_vm.content.title)}}),_vm._v(" "),_c('p',{staticClass:"mt--050 p p--lg resource__subtitle",domProps:{"innerHTML":_vm._s(_vm.content.description)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }